/*
  
*/
var ENMergeDateRangeRefiner = require('../EN/ENMergeDateRangeRefiner').Refiner;

exports.Refiner = function DEMergeDateRangeRefiner() {
    ENMergeDateRangeRefiner.call(this);

    this.pattern = function () {
        return /^\s*(bis(?:\s*(?:am|zum))?|\-)\s*$/i
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chrono-node/src/refiners/DE/DEMergeDateRangeRefiner.js
// module id = 1108
// module chunks = 0